"use client";

import { useEffect } from "react";
import { Loader2 } from "lucide-react";
import { getAuthToken } from "@/lib/auth";

export default function Home() {
  useEffect(() => {
    window.location.replace(resolveRootRedirect());
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-bg">
      <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
    </div>
  );
}

function resolveRootRedirect(): string {
  const rawHash = window.location.hash.startsWith("#")
    ? window.location.hash.slice(1)
    : "";
  if (!rawHash) {
    return getAuthToken() ? "/dashboard" : "/login";
  }

  const questionIndex = rawHash.indexOf("?");
  const hashPath = questionIndex === -1 ? rawHash : rawHash.slice(0, questionIndex);
  const hashQuery = questionIndex === -1 ? "" : rawHash.slice(questionIndex);
  const normalized = hashPath.replace(/\/+$/, "") || "/";

  if (normalized === "/" || normalized === "/login") {
    return normalized === "/login"
      ? `/login${hashQuery}`
      : getAuthToken()
        ? "/dashboard"
        : "/login";
  }

  if (normalized === "/my-feedback") return "/feedback?tab=mine";
  if (normalized === "/marketing/blog") return "/marketing?tab=blog";
  if (normalized === "/marketing/events") return "/marketing?tab=events";
  if (normalized === "/marketing/visitors") return "/marketing?tab=visitors";
  if (normalized === "/item-templates/new") return "/templates/item/new";
  if (normalized.startsWith("/item-templates/") && normalized.endsWith("/edit")) {
    return normalized.replace("/item-templates/", "/templates/item/");
  }
  if (normalized === "/inspection-templates/new") return "/templates/inspection/new";
  if (normalized.startsWith("/inspection-templates/") && normalized.endsWith("/edit")) {
    return normalized.replace("/inspection-templates/", "/templates/inspection/");
  }

  return `${normalized}${hashQuery}`;
}
